module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "dtai-news-content"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/home_en/0/detail/331"
    }
  }, [_vm._v("\n            【Invitation Letter】1"), _c('sup', [_vm._v("st")]), _vm._v(" Beijing Tiantan International Forum of Neurosurgery(BIFNS)\n          ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/home_en/1/detail/329"
    }
  }, [_vm._v("\n            【Invitation Letter】 Meeting of International Meningioma society\n          ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/home_en/2/detail/330"
    }
  }, [_vm._v("\n            【Invitation Letter】 Meningioma Society Announcement")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1baba27f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tiantan/link_c.vue
// module id = 774
// module chunks = 10